import CategoryHeader from './CategoryHeader';

export default CategoryHeader;
